import { TribunalCaseType } from '../../cases/types.js';
export var DKTribunalJobType;
(function (DKTribunalJobType) {
    DKTribunalJobType["CreateBetalingspaakrav"] = "CREATE_BETALINGSPAAKRAV";
    DKTribunalJobType["ResendBetalingspaakrav"] = "RESEND_BETALINGSPAAKRAV";
    DKTribunalJobType["Register1Paategning"] = "REGISTER_1_PAATEGNING";
    DKTribunalJobType["Register2Paategning"] = "REGISTER_2_PAATEGNING";
    DKTribunalJobType["ClosedObjection"] = "CLOSED_OBJECTION";
    DKTribunalJobType["CreateFogedrekvisition"] = "CREATE_FOGEDREKVISITION";
    DKTribunalJobType["RegisterInsolvency"] = "REGISTER_INSOLVENCY";
    DKTribunalJobType["RegisterPolicePresentation"] = "REGISTER_POLICE_PRESENTATION";
    DKTribunalJobType["CreateOtherFogedsager"] = "CREATE_OTHER_FOGEDSAGER";
})(DKTribunalJobType || (DKTribunalJobType = {}));
export const DEFAULT_NO_PHONE_MEETING_BELOW_AMOUNT = 250000;
export const shouldRequestPhoneMeeting = (caseSumOere, noPhoneMeetingBelowAmount) => {
    const threshold = noPhoneMeetingBelowAmount ?? DEFAULT_NO_PHONE_MEETING_BELOW_AMOUNT;
    return caseSumOere >= threshold;
};
export const tribunalDKJobReferenceCaseMap = {
    [DKTribunalJobType.RegisterInsolvency]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.DKFogedrekvisition,
    ],
    [DKTribunalJobType.CreateBetalingspaakrav]: [
        TribunalCaseType.DKBetalingspaakrav,
    ],
    [DKTribunalJobType.ClosedObjection]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.GLBetalingspaakrav,
    ],
    [DKTribunalJobType.Register1Paategning]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.GLBetalingspaakrav,
    ],
    [DKTribunalJobType.RegisterPolicePresentation]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.DKFogedrekvisition,
    ],
    [DKTribunalJobType.Register2Paategning]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.GLBetalingspaakrav,
    ],
    [DKTribunalJobType.ResendBetalingspaakrav]: [
        TribunalCaseType.DKBetalingspaakrav,
    ],
    [DKTribunalJobType.CreateFogedrekvisition]: [
        TribunalCaseType.DKFogedrekvisition,
    ],
    [DKTribunalJobType.CreateOtherFogedsager]: [
        TribunalCaseType.DKAndreFogedsager,
    ],
};
export const bpkDefaults = {
    rubrik1Creditor: '<p>{{case.creditor.name}} </p><p>{{case.creditor.address.address}} <br>{{case.creditor.address.zipcode}} {{case.creditor.address.city}}<br>Cvr.: {{creditorCentralRegisterId}}</p>',
    rubrik1Representative: '<p>{{collector.name}}</p><p>{{collector.address.address}} <br>{{collector.address.zipcode}} {{collector.address.city}}<br>Cvr.: {{collector.centralRegisterId}}<br>{{collectorEmail}}<br><br><br><br>Repræsentantens registrerings- og kontonummer:<br>{{collector.registrationNumber}} {{collector.accountNumber}} </p>',
    rubrik1ContactInformation: '<p>Hvis ja, kan fogedretten ringe til direkte telefonnummer:<br>{{collectorPhone}} </p><p>Repræsentantens sagsnummer:<br>{{journalNumber}}</p>',
};
//# sourceMappingURL=denmark.js.map